import {
    ClientStatus,
    IClient,
    IFeeSettingFields,
    IInsuranceVerificationFields,
} from "intake_shared/src/types";
import styles from "./InsuranceFeesDisplay.module.scss";
import { cn } from "../../../../helpers";

export function InsuranceAndFeesDisplay({ client }: { client: IClient }) {
    const clientInsuranceVerification =
        client[ClientStatus.INS_VERIFICATION] ||
        ({} as IInsuranceVerificationFields);
    const clientFees = (client[ClientStatus.FEE_SETTING] || {}) as IFeeSettingFields;

    return (
        <div className={styles.insuranceFeesContainer}>
            {Object.keys(clientInsuranceVerification).length > 0 && (
                <div className={styles.insuranceFees}>
                    <div className={styles.fees}>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>INN Deductible</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.INNDed || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>INN Copay</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.INNCo || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>INN Out-of-pocket</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.INNOOP || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>INN Coinsurance</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.INNCoins || "--"}
                            </p>
                        </div>
                    </div>
                    <div className={styles.fees}>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>OON Deductible</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.OONDed || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>OON Copay</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.OONCo || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>OON Out-of-pocket</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.OONOOP || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>OON Coinsurance</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.OONCoins || "--"}
                            </p>
                        </div>
                    </div>
                    <div className={cn(styles.fees, styles.otherFees)}>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>UCR</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.UCR || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>Calendar year</p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.CalYr || "--"}
                            </p>
                        </div>
                        <div className={styles.fee}>
                            <p className={styles.feeLabel}>
                                Accumulations (calendar year)
                            </p>
                            <p className={styles.feeValue}>
                                {clientInsuranceVerification.accumulations_cal_yr ||
                                    "--"}
                            </p>
                        </div>
                    </div>
                </div>
            )}

            <div className={styles.fees}>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Masters Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.masters_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>INN Masters Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.inn_masters_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Psych. Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.psychiatry_fee || "--"}
                    </p>
                </div>

                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Psych. A Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.psychiatry_fee_a || "--"}
                    </p>
                </div>

                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Psych. B Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.psychiatry_fee_b || "--"}
                    </p>
                </div>

                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Psych. C Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.psychiatry_fee_c || "--"}
                    </p>
                </div>

                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Career Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.career_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Gifted Assessment Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.gifted_assessment_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>
                        Short Term Evaluation & Documentation Fee
                    </p>
                    <p className={styles.feeValue}>
                        {clientFees.short_term_evaluation_documentation_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Extern Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.extern_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Intern Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.intern_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Dr Fee</p>
                    <p className={styles.feeValue}>{clientFees.dr_fee || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Dr Fee A</p>
                    <p className={styles.feeValue}>{clientFees.dr_fee_a || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Dr Fee B</p>
                    <p className={styles.feeValue}>{clientFees.dr_fee_b || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Dr Fee C</p>
                    <p className={styles.feeValue}>{clientFees.dr_fee_c || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Lic Fee</p>
                    <p className={styles.feeValue}>{clientFees.lic_fee || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Kap Fee</p>
                    <p className={styles.feeValue}>{clientFees.kap_fee || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Nutrition Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.nutrition_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Nutrition Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.inn_nutrition_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Lic Fee A</p>
                    <p className={styles.feeValue}>{clientFees.lic_a_fee || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Lic Fee B</p>
                    <p className={styles.feeValue}>{clientFees.lic_b_fee || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Lic Fee C</p>
                    <p className={styles.feeValue}>{clientFees.lic_c_fee || "--"}</p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Self Pay</p>
                    <p className={styles.feeValue}>
                        {String(clientFees.is_self_pay || "--")}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Testing Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.testing_fee || "--"}
                    </p>
                </div>
                <div className={styles.fee}>
                    <p className={styles.feeLabel}>Intern/Extern Testing Fee</p>
                    <p className={styles.feeValue}>
                        {clientFees.intern_extern_testing_fee ?? "--"}
                    </p>
                </div>
            </div>
        </div>
    );
}
